import React from "react";
import Card from "react-bootstrap/Card";
import { TiStar } from "react-icons/ti";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Anamay Kashiv </span>
            from <span className="purple"> MP, India.</span>
            <br />
            I am a final year MCA Student.
            <br />
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <TiStar /> Playing Sports
            </li>
            <li className="about-activity">
              <TiStar /> Writing Tech Blogs
            </li>
            <li className="about-activity">
              <TiStar /> Playing Video Games
            </li>
            <li className="about-activity">
              <TiStar /> Singing
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Better a cruel truth than a comfortable delusion!"{" "}
          </p>
          <footer className="blockquote-footer">Anamay</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
